// 사이트 UI 문구의 한국어/영어 번역 딕셔너리 (고유명사는 원제 유지)

export const translations = {
  ko: {
    introLabels: {
      name: '이름',
      birth: '생년월일',
      agency: '소속사',
      group: '소속 그룹',
      position: '포지션',
    },
    introValues: {
      name: '조원상',
      position: '프로듀싱 & 베이스',
    },
    footerNotice: '본 사이트는 개인이 만든 사이트로서 공식적이지 않습니다.',
    scGuide:
      '모바일 환경에서는 Listen in browser를 클릭해 주셔야 음악을 재생하실 수 있습니다.',
    parts: {
      작사: '작사',
      작곡: '작곡',
      편곡: '편곡',
      베이스: '베이스',
    },
  },
  en: {
    introLabels: {
      name: 'Name',
      birth: 'Birth',
      agency: 'Agency',
      group: 'Group',
      position: 'Position',
    },
    introValues: {
      name: 'Wonsang Cho',
      position: 'Producing & Bass',
    },
    footerNotice: 'This site is not official, as a personally created site.',
    scGuide: "On mobile, tap 'Listen in browser' to play the track.",
    parts: {
      작사: 'Lyrics',
      작곡: 'Composition',
      편곡: 'Arrangement',
      베이스: 'Bass',
    },
  },
}
